// extracted by mini-css-extract-plugin
export default {"btop":"_5affbd6be8 aaeef95505 c4ae509c6d","icon":"_5fdd5c4ba9 ef12e8d5ac","btoppink":"ef414f652d c577a069bf"};